import { useEffect } from 'react';
import { Activity } from 'lucide-react';

const LOGIN_PORTAL_URL =
  process.env.REACT_APP_LOGIN_PORTAL_URL || 'https://login.someaditya.in/';

// All real authentication lives at login.someaditya.in (the shared SSO
// portal for all someaditya.in apps). This component only exists so that
// the legacy /login bookmark continues to work — it immediately
// redirects to the portal with the trading app as the return target.
export default function Login() {
  useEffect(() => {
    const returnTo = encodeURIComponent(`${window.location.origin}/`);
    window.location.replace(`${LOGIN_PORTAL_URL}?return_to=${returnTo}`);
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ background: 'linear-gradient(135deg, #0a0e1a 0%, #1a1f35 100%)' }}
    >
      <Activity className="animate-spin" size={48} style={{ color: '#60a5fa' }} />
    </div>
  );
}
